export const TITLE_ALL_VERSIONS = 'All Versions';
export const TAG_VERSION_DEFAULT = {
  tags: ['Latest'],
  as_of: 'latest',
};

export type DatasetTab = {
  id:
    | 'experiments'
    | 'examples'
    | 'evaluators'
    | 'pairwise-experiments'
    | 'few-shot-search';
  tabName: string;
  showVersioning: boolean;
  showForSelfHosted: boolean;
};

export const DATASET_TABS: DatasetTab[] = [
  {
    id: 'experiments',
    tabName: 'Experiments',
    showVersioning: true,
    showForSelfHosted: true,
  },
  {
    id: 'examples',
    tabName: 'Examples',
    showVersioning: true,
    showForSelfHosted: true,
  },
  {
    id: 'evaluators',
    tabName: 'Evaluators',
    showVersioning: false,
    showForSelfHosted: true,
  },
  {
    id: 'pairwise-experiments',
    tabName: 'Pairwise Experiments',
    showVersioning: false,
    showForSelfHosted: true,
  },
  {
    id: 'few-shot-search',
    tabName: 'Few-shot search',
    showVersioning: false,
    showForSelfHosted: false,
  },
];

export const getTabIndex = (tabId: DatasetTab['id']) => {
  return DATASET_TABS.findIndex((tab) => tab.id === tabId);
};
